// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__27DZY","head":"ProcedureTableInfo_head__PbDq1"};